import React from 'react';

export const TitleUI = (props) => {
    return (
        <div className="title">
            {
                props.icon && props.icon.includes('mdi') ? (<i className={props.icon} />) : (<i className="material-icons">{props.icon}</i>)
            }
            {` ${props.label}`}
        </div>
    );
};

export const SubtitleUI = (props) => {
    return (
        <div className={`subtitle ${props.truncate ? "truncate" : ""}`}>
            {props.separator ? "|" : ""}
            {props.icon && props.icon.includes('mdi') ? <i className={props.icon} /> : <i className="material-icons">{props.icon}</i>}
            {` ${props.label}`}
        </div>
    );
};

export const ButtonIconUI = (props) => {
    return (
        <div className="title" style={props.style ? props.style : { float: 'right', margin: '10px' }}>
            <i className={props.icon} style={{ cursor: 'pointer' }} onClick={props.onClick} />
        </div>
    );
};
